module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button",
    attrs: {
      "href": _vm._url,
      "target": _vm.target
    },
    on: {
      "click": function($event) {
        _vm.onClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "label",
    class: {
      'is-white': _vm.white
    }
  }, [_vm._v(_vm._s(_vm.label))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e2199b82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base-button.vue
// module id = 504
// module chunks = 0